import React from 'react';
import config from '../../../utils/config';

function CustomExportYellow() {
	return (
		<div id="main-container" className="main-container nav-effect-1">
			<iframe
				style={{ top: '0px' }}
				id="ouilink-iframe"
				src={`${config.reportingV4Url}custom-export-yellow${window.location.search}`}
			/>
		</div>
	);
}
export default CustomExportYellow;
